import React, { useEffect, useState } from 'react'
import { getKakaoToken, getUserData } from '../../api/kakao'

export default function Oauth() {
  const [kakaoToken, setKakaoToken] = useState<string>('')
  const [userData, setUserData] = useState<any>()
  useEffect(() => {
    authTest()
  }, [])
  useEffect(() => {
    if (kakaoToken && userData) {
      sendMessage()
    }
  }, [kakaoToken, userData])
  const sendMessage = () => {
    if (window.opener) {
      const message = {
        type: 'URL_UPDATE',
        kakaoToken: kakaoToken,
        userData: userData,
      }
      window.opener.postMessage(message)
      window.close()
    }
  }

  const authTest = () => {
    getKakaoToken()
      .then((res) => {
        if (res) {
          setKakaoToken(res.data.access_token)
          getUserData(res.data.access_token).then((response) => {
            setUserData(response.data)
          })
        }
      })
      .catch((err) => console.log(err))
  }

  // 페이지 로드 시 현재 URL 전송

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '20vh' }}></div>
    </>
  )
}
